import React, { useEffect } from "react";
import { Form, Button, InputNumber, Space } from "antd";
import { ClockCircleOutlined, PercentageOutlined } from "@ant-design/icons";
const FormBatchDefaultConfiguration = (props) => {
  useEffect(() => {
    form.setFieldsValue(props.initialValues);
  }, [props.initialValues]);
  const [form] = Form.useForm();
  return (
    props.initialValues &&
    props.initialValues.batch_default_setting && (
      <Form form={form} onFinish={props.onFinish}>
        <div className="customTable">
          <table>
            <thead>
              <tr>
                <th>Batch</th>
                <th>Slots percentage</th>
                <th>Show time(Hours)</th>
                <th>Expiry Time(Hours)</th>
              </tr>
            </thead>
            <tbody>
              <Form.List name={"batch_default_setting"}>
                {(fields, { add, remove }) => (
                  <>
                    {fields.map((field, index) => {
                      return (
                        <tr
                          style={{ verticalAlign: "baseline" }}
                          direction="horizontal"
                          size={12}
                          key={field.key}
                        >
                          <td>
                            <Form.Item
                              disabled
                              key={field.key}
                              name={[field.name, "batchLevel"]}
                              initialValue={
                                props.initialValues.batch_default_setting[index]
                                  .batch.batchLevel
                              }
                              // label={`${index + 1}`}
                              // rules={[
                              //   {
                              //     required: true,
                              //     message: "Slot Percentage is Required",
                              //   },
                              // ]}
                            >
                              <InputNumber disabled />
                            </Form.Item>
                          </td>
                          <td>
                            <Form.Item
                              key={field.key}
                              name={[field.name, "slotsPercentage"]}
                              rules={[
                                {
                                  required: true,
                                  message: "Slot Percentage is Required",
                                },
                                {
                                  type: "number",
                                  min: 0,
                                  // max: 100,
                                  message:
                                    "Please enter minimum Slot Percentage",
                                },
                                {
                                  type: "number",
                                  max: 100,
                                  message:
                                    "Please maximum value is 100 Slot Percentage",
                                },
                              ]}
                            >
                              <InputNumber
                                disabled={
                                  props.isDisabled === false ? false : true
                                }
                                placeholder="Slot Percentage"
                                min={0}
                                max={100}
                                prefix={<PercentageOutlined />}
                              />
                            </Form.Item>
                          </td>
                          <td>
                            <Form.Item
                              key={field.key}
                              name={[field.name, "startDisplayHours"]}
                              rules={[
                                {
                                  required: true,
                                  message: "Show Time is Required",
                                },
                              ]}
                            >
                              <InputNumber
                                disabled={
                                  props.isDisabled === false ? false : true
                                }
                                placeholder="Show Time"
                                min={0.01}
                                prefix={<ClockCircleOutlined />}
                              />
                            </Form.Item>
                          </td>
                          <td>
                            <Form.Item
                              key={field.key}
                              name={[field.name, "endDisplayHours"]}
                              rules={[
                                {
                                  required: true,
                                  message: "Expiry Time is Required",
                                },
                              ]}
                            >
                              <InputNumber
                                disabled={
                                  props.isDisabled === false ? false : true
                                }
                                placeholder="Expiry Time"
                                min={0.01}
                                prefix={<ClockCircleOutlined />}
                              />
                            </Form.Item>
                          </td>
                        </tr>
                      );
                    })}
                  </>
                )}
              </Form.List>
              {props.isDisabled === false ? (
                <tr>
                  <td colSpan={4}>
                    <Form.Item>
                      <Space>
                        <Button className="submit" htmlType="submit">
                          Submit
                        </Button>
                        <Button onClick={props.editCancel}>Cancel</Button>
                      </Space>
                    </Form.Item>
                  </td>
                </tr>
              ) : (
                ""
              )}
            </tbody>
          </table>
        </div>
      </Form>
    )
  );
};

export default FormBatchDefaultConfiguration;
